module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-zigzag-light-blue-94c9237d1b8dc0fae1f1591a04203ca7.svg";